import { render, staticRenderFns } from "./WebPartImageDesigner.vue?vue&type=template&id=4c737b56&scoped=true&"
import script from "./WebPartImageDesigner.vue?vue&type=script&lang=js&"
export * from "./WebPartImageDesigner.vue?vue&type=script&lang=js&"
import style0 from "./WebPartImageDesigner.vue?vue&type=style&index=0&id=4c737b56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c737b56",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c737b56')) {
      api.createRecord('4c737b56', component.options)
    } else {
      api.reload('4c737b56', component.options)
    }
    module.hot.accept("./WebPartImageDesigner.vue?vue&type=template&id=4c737b56&scoped=true&", function () {
      api.rerender('4c737b56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/featureOnePage/webParts/WebPartImageDesigner.vue"
export default component.exports